// extracted by mini-css-extract-plugin
export var bubble = "_37-0";
export var container = "_37-f";
export var contrastBorder = "_37-g";
export var greyOut = "_37-2";
export var initialsColor0 = "_37-3";
export var initialsColor1 = "_37-4";
export var initialsColor10 = "_37-d";
export var initialsColor11 = "_37-e";
export var initialsColor2 = "_37-5";
export var initialsColor3 = "_37-6";
export var initialsColor4 = "_37-7";
export var initialsColor5 = "_37-8";
export var initialsColor6 = "_37-9";
export var initialsColor7 = "_37-a";
export var initialsColor8 = "_37-b";
export var initialsColor9 = "_37-c";
export var initialsWrapper = "_37-1";
export var large = "_37-l";
export var medium = "_37-k";
export var mediumSmall = "_37-j";
export var mediumSmallMedium = "_37-o";
export var micro = "_37-h";
export var small = "_37-i";
export var tiny = "_37-n";
export var xTiny = "_37-m";